import { cn } from "@/lib/cn";

/**
 * The Sellhiz mark: a slanted S trailing speed lines on its left, its tail
 * tapering into one of them. Drawn once here for every Sellhiz logo;
 * public/favicon.svg is the same drawing.
 */
export function SellhizLogo({ className, title }: { className?: string; title?: string }) {
  return (
    <svg
      viewBox="0 0 1024 1024"
      className={cn("shrink-0", className)}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      data-testid="sellhiz-logo"
    >
      <rect width="1024" height="1024" rx="230" fill="#244df5" />
      <g transform="translate(219.9 79.2) scale(0.8323)">
        <g transform="skewX(-11)" fill="#fff">
          <rect x="168" y="300" width="302" height="46" rx="23" />
          <rect x="110" y="386" width="340" height="46" rx="23" />
          <rect x="200" y="472" width="266" height="46" rx="23" />
          <path d="M444.9 668 439.7 659.4C413.6 616.8 396 558 356 558H153A23 23 0 0 0 153 604H244C282 604 288.9 681.4 320.3 732.6L325.5 741.1Z" />
          <rect x="210" y="644" width="190" height="46" rx="23" />
          <rect x="150" y="730" width="280" height="46" rx="23" />
          <path
            d="M724 336C688 280 626 254 556 254 452 254 386 306 386 384 386 466 460 494 560 516 666 539 736 570 736 654 736 738 662 786 562 786 484 786 418 758 380 696"
            fill="none"
            stroke="#fff"
            strokeWidth="140"
            strokeLinejoin="round"
          />
          <circle cx="724" cy="336" r="70" />
        </g>
      </g>
    </svg>
  );
}
